import { useMemo } from 'react'
import MemoryNetworkCanvas from '@/frontend/components/DigitalWorkers/memory-bank/MemoryNetworkCanvas'
import { toNetworkData } from '@/frontend/components/DigitalWorkers/memory-bank/utils'
import type { MemoryLinkType, MemoryRow } from '@/frontend/components/DigitalWorkers/memory-bank/types'
import type { ProjectKnowledgePayload } from '@/frontend/features/Fde/types'

const LINK_TYPES = new Set<MemoryLinkType>(['semantic', 'temporal', 'entity', 'causal'])

export default function ProjectKnowledgeMap({ knowledge, selected, onSelect, onClear, label }: {
  knowledge: ProjectKnowledgePayload
  selected: MemoryRow | null
  onSelect: (row: MemoryRow) => void
  onClear: () => void
  label: string
}) {
  const network = useMemo(() => toNetworkData(knowledge.graph), [knowledge.graph])

  return (
    <div className="memory-neural-stage relative h-full min-h-0 overflow-hidden bg-background">
      <div aria-hidden="true" className="memory-neural-grid pointer-events-none absolute inset-0 z-10 opacity-60" />
      <MemoryNetworkCanvas
        data={network}
        variant="constellation"
        visibleLinkTypes={LINK_TYPES}
        colorField="mentioned_at"
        showLabels
        selectedId={selected?.id}
        highlightedIds={selected ? [selected.id] : []}
        ariaLabel={label}
        onSelect={onSelect}
        onClear={onClear}
      />
    </div>
  )
}
